import { Component, Input, ElementRef, AfterViewInit, OnChanges, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-number-counter',
  templateUrl: './number-counter.component.html',
  styleUrls: ['./number-counter.component.scss'],
})
export class NumberCounterComponent implements OnChanges, AfterViewInit, OnDestroy {
  @Input() countValue!: number;
  @Input() duration: number = 2000;
  @Input() shouldPlay?: boolean;
  playing = false;
  destroyed = false;

  constructor(
    private nativeElementRef: ElementRef,
  ) {
  }

  ngOnChanges(): void {
    if(this.shouldPlay){
      this.start();
    }
  }
  
  ngAfterViewInit(): void {
      if(this.shouldPlay) {
        this.start();
      }
  }

  ngOnDestroy(): void {
      this.destroyed = true;
  }

  start(): void {
    if(this.playing) {
      return;
    }
    if(this.destroyed) {
      return;
    }
    this.playing = true;
    const targetValue = this.countValue;
    const duration = this.duration;
    let currentCount = 0;
    const element = this.nativeElementRef.nativeElement;
    let previousTimestamp = performance.now();
    const range = targetValue - currentCount;
    
    const countNumbers = () => {
      const currentTimestamp = performance.now();
      const deltaTime = currentTimestamp - previousTimestamp;
      const relativeProgress = deltaTime / duration;
      const deltaValue = relativeProgress * range;
      const distance = Math.abs(targetValue - currentCount);
      if(distance <= Math.abs(deltaValue)){
        currentCount = targetValue;
        element.innerHTML = Math.trunc(currentCount).toString();
      }else {
        currentCount += deltaValue;
        element.innerHTML = Math.trunc(currentCount).toString();
        previousTimestamp = currentTimestamp;
        requestAnimationFrame(countNumbers);
      }
    };
    countNumbers();
  }
}
